<template>
<div>
</div>
</template>


<script>

import { logout } from '../api/api.js';

export default {
	name: 'Logout',
	data() {
		return {}
	},
	beforeCreate () {
		logout();
		this.$router.push('/acceso');
	},
}
</script>
